// Legge l'URL di base dell'API dalle variabili d'ambiente di Vite.
// Il prefisso VITE_ è obbligatorio per esporre le variabili al frontend.
// In produzione, imposteremo VITE_API_BASE_URL all'URL del nostro servizio Cloud Run.
// Per lo sviluppo locale, usiamo dinamicamente l'IP/hostname corrente del browser
// così è possibile testare la webapp da altri device nella LAN.
const originHost =
    typeof window !== 'undefined' && window.location?.hostname
        ? window.location.hostname
        : 'localhost';
const defaultLocalApi = `http://${originHost}:8000`;

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || defaultLocalApi;

// Esportiamo l'URL completo per le chiamate HTTP
export const HTTP_API_URL = API_BASE_URL;

// URL per i WebSocket, derivato dall'URL base dell'API
export const WEBSOCKET_URL = API_BASE_URL.replace(/^http/, 'ws');
